// MusicListField.js
import { useFieldArray } from 'react-hook-form';
import {
    Alert,
    Box,
    Button,
    Grid,
    IconButton,
    List,
    ListItem,
    Typography,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import ClearIcon from '@mui/icons-material/Clear';
import PropTypes from 'prop-types';
import FormTextField from '../../../../components/FormFields/FormTextField';

const MusicListField = ({ fieldName, subfields, emptyMsg }) => {
    const { fields, append, remove } = useFieldArray({ name: fieldName });

    const newElement = () =>
        Object.fromEntries(subfields.map((subfield) => [subfield, '']));

    const listFields = fields.map((field, i) => (
        <ListItem
            key={field.id}
            disableGutters
            sx={{
                p: 2,
                mb: 2,
                border: '1px solid',
                borderColor: 'grey.300',
                borderRadius: 2,
                backgroundColor: 'grey.50',
            }}
        >
            <Grid container spacing={2}>
                {subfields.map((subfield) => (
                    <Grid item xs={12} sm={6} md={4} key={subfield}>
                        <FormTextField
                            fieldName={`${fieldName}.[${i}].${subfield}`}
                            label={subfield.charAt(0).toUpperCase() + subfield.slice(1)}
                            variant="outlined"
                            fullWidth
                        />
                    </Grid>
                ))}
                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <IconButton
                        aria-label="delete"
                        onClick={() => remove(i)}
                        sx={{ color: 'taphaBlue.dark' }}
                    >
                        <ClearIcon />
                    </IconButton>
                </Grid>
            </Grid>
        </ListItem>
    ));

    return (
        <Box>
            <List sx={{ width: '100%' }} disablePadding>
                {listFields}
                {!listFields.length && (
                    <Alert severity="info" sx={{ borderRadius: 3 }}>
                        {emptyMsg}
                    </Alert>
                )}
            </List>
            <Box display="flex" justifyContent="flex-end" width="100%" pt={2}>
                <Button
                    onClick={() => append(newElement())}
                    size="small"
                    variant="contained"
                    startIcon={<AddIcon />}
                    sx={{ backgroundColor: 'taphaBlue.main' }}
                >
                    Lisää kappale
                </Button>
            </Box>
        </Box>
    );
};

MusicListField.propTypes = {
    fieldName: PropTypes.string.isRequired,
    subfields: PropTypes.arrayOf(PropTypes.string).isRequired,
    emptyMsg: PropTypes.string.isRequired,
};

export default MusicListField;